module.exports = __webpack_public_path__ + "static/media/info.15b66924.svg";